import { useValidation } from "hooks/useValidation";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

export function TemplateBuilderTextAreaPreview(props) {
    const [isValid, errors, validate] = useValidation();    

    useEffect(() => {
        if (!props.disabled) {
            const rule = { fieldName: "answer", maxLength: props.question.maxLength, minLength: props.question.minLength };
            
            validate([rule], props.answer);
        }
    }, [props.answer, props.disabled]);

    useEffect(() => {
        if (props.answer && !isValid !== props.answer.notValid) {
            props.onChange({
                ...props.answer,
                notValid: !isValid,
                error: errors.answer
            });
        }
    }, [isValid])

    const onChange = (newValue) => {
        props.onChange({
            $answerType: "TextArea",
            questionId: props.question.id,
            answer: newValue ?? "",
            isAnswered: newValue != null || newValue !== '',
            notValid: !isValid,
            error: errors.answer
        });
    }


    return <div className="check-preview-form-field">
        <div className="check-preview-input-container">
            <textarea
                onChange={(event) => onChange(event.currentTarget.value)}
                value={props.answer?.answer ? props.answer.answer : ""}
            >
            </textarea>
            {props.deleteComponent}
        </div>
        {props.addAnotherComponent}
    </div>
}

TemplateBuilderTextAreaPreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    addAnotherComponent: PropTypes.node.isRequired,
    deleteComponent: PropTypes.node.isRequired
};